import { AvailableModules, Features } from 'generated/featureDefinitions'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { ProjectsUpsellRequestSources } from '../constants'

export const UpsellContributorsMessage = () => {
  return (
    <UpsellingKit.EmptyState
      moduleRequested={AvailableModules.projects}
      featureRequested={Features.projects_contributors}
      requestReason={ValidReasons.UpgradeFromLegacy}
      requestSource={ProjectsUpsellRequestSources.contributors}
      title={i18n.t('project_management.upselling.title')}
      description={i18n.t('project_management.upselling.people')}
      buttonLabel={i18n.t('project_management.upselling.cta')}
      variant="table"
    />
  )
}
